module.exports = __WEBPACK_EXTERNAL_MODULE_4__;


//////////////////
// WEBPACK FOOTER
// external {"root":"PropTypes","commonjs2":"prop-types","commonjs":"prop-types","amd":"prop-types"}
// module id = 4
// module chunks = 0